var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "white",
    stroke: "#CBD5E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.832 11.75C31.0972 11.75 31.3516 11.8554 31.5391 12.0429C31.7267 12.2304 31.832 12.4848 31.832 12.75V28.75C31.832 29.0152 31.7267 29.2696 31.5391 29.4571C31.3516 29.6446 31.0972 29.75 30.832 29.75H12.832C12.5668 29.75 12.3125 29.6446 12.1249 29.4571C11.9374 29.2696 11.832 29.0152 11.832 28.75V12.75C11.832 12.4848 11.9374 12.2304 12.1249 12.0429C12.3125 11.8554 12.5668 11.75 12.832 11.75H30.832ZM16.832 13.75H13.832V27.75H16.832V13.75ZM29.832 13.75H18.832V27.75H29.832V13.75Z",
    fill: "#63658E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageCircled);
export default __webpack_public_path__ + "static/media/pageCircled.4b80be0d62f0039d0dbfa7d744d94140.svg";
export { ForwardRef as ReactComponent };